import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG } from 'CorePackage/MainModule/constants/dateFormat';

import styles from './styles.module.scss';

interface IKnmFace {
  passportData?: IKnmPreview;
}

export const KnmFace = ({ passportData }: IKnmFace) => (
  <div className={styles.ColumnContent}>
    <span className={styles.SectionTitle}>Субъект КНМ</span>
    {passportData?.subject && typeof passportData?.subject.resident === 'boolean' && (
      <div className={styles.Row}>
        <div className={styles.ColText}>Субъект проверки - Резидент РФ</div>
        <div className={styles.ColValue}>{passportData?.subject.resident ? 'Есть' : 'Нет'}</div>
      </div>
    )}
    {passportData?.subject && passportData?.subject.typeName && (
      <div className={styles.Row}>
        <div className={styles.ColText}>Тип субъекта КНМ</div>
        <div className={styles.ColValue}>{passportData?.subject.typeName}</div>
      </div>
    )}
    {passportData?.subject && (
      <div className={styles.Row}>
        <div className={styles.ColText}>
          Наименование юридического лица (ЮЛ) или фамилия, имя, отчество (последнее – при наличии) индивидуального
          предпринимателя, в отношении которого проводится КНМ
        </div>
        <div className={styles.ColValue}>{passportData?.subject.orgName}</div>
      </div>
    )}
    {passportData?.subject && (
      <div className={styles.Row}>
        <div className={styles.ColText}>ИНН проверяемого лица</div>
        <div className={styles.ColValue}>{passportData?.subject.inn}</div>
      </div>
    )}
    {passportData?.subject && (
      <div className={styles.Row}>
        <div className={styles.ColText}>ОГРН проверяемого лица</div>
        <div className={styles.ColValue}>{passportData?.subject.ogrn}</div>
      </div>
    )}
    {passportData?.subject && passportData?.subject.registrationDate && (
      <div className={styles.Row}>
        <div className={styles.ColText}>
          Дата присвоения ОГРН (дата регистрации) юридического лица (ЮЛ) или индивидуального предпринимателя (ИП)
        </div>
        <div className={styles.ColValue}>
          {formatDate({ date: passportData?.subject.registrationDate, dateFormat: DATE_FORMAT_LONG })}
        </div>
      </div>
    )}
  </div>
);
